import { ETrackerEvents, trackCustom } from '../index';

import { formatTrackerMoney, type IRechargePayExtras } from './recharge-result';

/** 创单成功且拿到业务订单号时上报 */
export function trackOrderCreate(params: {
    order_id: string;
    gear_id: string;
    payExtras: IRechargePayExtras;
    payment_method: string;
    /** 页面级触发场景（与 staticContext 同源，不覆盖）；弹窗直拉为 recharge_pop_up */
    trigger_scene?: string;
    /**
     * 活动商品来源埋点标识（如 low_price_coins）；普通档位不传。
     * BI_TRACK_ORDER_FROM_FIELD → payload `order_from`；可与 payExtras.order_from 二选一。
     */
    order_from?: string;
    activity_id?: string;
    activity_instance_id?: string;
    offer_id?: string;
    paywall_style: string;
}): void {
    const {
        order_id,
        gear_id,
        payExtras,
        payment_method,
        trigger_scene,
        order_from,
        activity_id,
        activity_instance_id,
        offer_id,
        paywall_style,
    } = params;
    if (!order_id?.trim()) {
        return;
    }

    const payload: Record<string, string | number> = {
        order_id,
        gear_id,
        money: formatTrackerMoney(payExtras.money),
        goods_type: payExtras.goods_type,
        payment_method,
        paywall_style,
    };
    if (payExtras.goods_type === 'recharge') {
        payload.coin = payExtras.coin ?? 0;
        payload.bonus = payExtras.bonus ?? 0;
    }
    if (trigger_scene) {
        payload.trigger_scene = trigger_scene;
    }
    // BI_TRACK_ORDER_FROM_FIELD：活动商品来源（若 BI 改名同步替换 key）
    const trackOrderFromValue = order_from ?? payExtras.order_from;
    if (trackOrderFromValue) {
        payload.order_from = trackOrderFromValue;
    }
    if (activity_id) {
        payload.activity_id = activity_id;
    }
    if (activity_instance_id) {
        payload.activity_instance_id = activity_instance_id;
    }
    if (offer_id) {
        payload.offer_id = offer_id;
    }

    trackCustom(ETrackerEvents.ORDER_CREATE, payload);
}
